import Vue from 'vue'

// 引入devextreme的样式表
import zhMessages from "devextreme/localization/messages/zh.json";
import { locale, loadMessages } from "devextreme/localization";
import 'devextreme/dist/css/dx.common.css'
//此为组件主题样式，可修改dx.dark、dx.light、dx.darkmoon等，详情见官方API
// import 'devextreme/dist/css/dx.light.css'
// import 'devextreme/dist/css/dx.dark.css'
import "@/themes/generated/theme.base.css"
// import "@/themes/generated/dx.generic.custom-scheme.css"

import notify from 'devextreme/ui/notify';

import DxButton from "devextreme-vue/button";
// 表单相关组件
import { DxDateBox ,DxButton as DxTextBoxButton} from 'devextreme-vue/date-box';
import { DxTextBox, } from 'devextreme-vue/text-box';
import { DxTextArea } from 'devextreme-vue/text-area';
import { DxForm, DxGroupItem, DxSimpleItem, DxLabel,DxButtonItem,DxTabbedItem,DxTabPanelOptions,DxNumericRule,DxEmailRule} from 'devextreme-vue/form';
import { DxSelectBox, } from 'devextreme-vue/select-box';
import {DxCheckBox} from 'devextreme-vue/check-box';
import { DxRadioGroup} from 'devextreme-vue/radio-group';
import { DxNumberBox } from 'devextreme-vue/number-box';
import {DxValidator} from 'devextreme-vue/validator';
import {DxTagBox} from 'devextreme-vue/tag-box';
//导入
import { DxFileUploader } from 'devextreme-vue/file-uploader';
//下拉框表格
import DxDropDownBox from 'devextreme-vue/drop-down-box';
// 菜单组件
import { DxMenu } from 'devextreme-vue/menu';
import { DxList, } from 'devextreme-vue/list';

//标签页
import {DxTabPanel, DxItem} from "devextreme-vue/tab-panel";
import DxTabs from 'devextreme-vue/tabs';
//表格组件
import {DxDataGrid,DxColumn,DxExport,DxGrouping,DxGroupPanel,DxSorting, DxLoadPanel,DxSelection,
    DxEditing,DxPager,DxPaging,DxLookup, DxSearchPanel,DxScrolling,DxFilterRow,DxHeaderFilter,
    DxRequiredRule,DxColumnFixing,DxToolbar,DxColumnChooser,DxStateStoring} from 'devextreme-vue/data-grid';
// 弹框
import { DxPopup, DxPosition, DxToolbarItem } from 'devextreme-vue/popup';
// 颜色盒子
import DxColorBox from 'devextreme-vue/color-box';
//切换按钮
import DxSwitch from 'devextreme-vue/switch';
import DxTreeView from "devextreme-vue/ui/tree-view";
import DxScrollView from "devextreme-vue/scroll-view"
// layout
import { DxBox } from 'devextreme-vue/box';
// 导出文件相关

loadMessages(zhMessages);
locale(navigator.language);

Vue.prototype.$notify = notify
let nameList = {
  DxButton,
  DxDateBox, DxTextBox, DxTextArea, DxForm, DxGroupItem, DxSimpleItem, DxLabel,DxButtonItem,DxTabbedItem,DxTabPanelOptions,DxNumericRule,DxEmailRule, DxSelectBox,DxCheckBox,DxRadioGroup,DxNumberBox,
  DxPopup, DxPosition, DxToolbarItem,DxDropDownBox,DxColumnChooser,DxFileUploader,DxStateStoring,DxTreeView,
  DxMenu, DxList,
  DxTabPanel, DxItem,
  DxTabs,
  DxDataGrid,DxColumn,DxExport,DxGrouping,DxGroupPanel,DxSorting, DxLoadPanel,DxSelection,DxEditing,DxPager,DxPaging,DxLookup, DxSearchPanel,DxScrolling,DxFilterRow,DxHeaderFilter,DxRequiredRule,DxColumnFixing,
  DxColorBox,DxSwitch,DxToolbar,DxValidator,DxTextBoxButton,DxTagBox,DxScrollView,
  DxBox
  // Workbook,saveAs,exportDataGrid,jsPDF,exportDataGridToPdf,
}

function useComponent(nameList = {}) {
  for(let [key, value] of Object.entries(nameList)) {
    Vue.component(key, value)
  }
}
useComponent(nameList)
